export default __webpack_public_path__ + "static/media/Frame.e2cb3dae.svg";